import React, { useEffect } from 'react';
import { useSportsBetting } from '../../context/SportsBettingContext';
import { isSportsBettingPopupEnabled } from '../../config/sportsBettingConfig';

const SportsBettingWrapper = ({ children }) => {
  const { showSportsBettingPopup } = useSportsBetting();

  useEffect(() => {
    // Only show popup if it's enabled
    if (isSportsBettingPopupEnabled()) {
      showSportsBettingPopup();
    }
  }, [showSportsBettingPopup]);

  return <>{children}</>;
};

export default SportsBettingWrapper; 